import {PostIncomeTaxDetailsParams} from 'domain/usecases';
import {makePostIncomeTaxDetails} from 'main/factories/usecases';

export const postIncomeTaxDetails = async (params: PostIncomeTaxDetailsParams) => {
	const response = await makePostIncomeTaxDetails().post(params);
	return response;
};
